import ParameterErrors from '../errors/ParameterErrors';
import eventEnable from '../core/eventEnable';
const { throwNotProvided } = ParameterErrors;
export default class Models {
    constructor(props) {
		eventEnable(this);
		this._set =new Set();
		this.add = this.add.bind(this);
		this.remove = this.remove.bind(this);
		this._dispatchAdded = this._dispatchAdded.bind(this);
		this._dispatchRemoved = this._dispatchRemoved.bind(this);
    }
	add(modelRef){
		if(this._set.has(modelRef))return;
		this._set.add(modelRef);
		this._dispatchAdded(modelRef);
	}
	remove(modelRef){
		if(!this._set.has(modelRef))return;
		this._set.delete(modelRef);
		this._dispatchRemoved(modelRef);
	}
	_dispatchAdded(modelRef){
		this.dispatchEvent({type:'added', modelRef:modelRef});
	}
	_dispatchRemoved(modelRef){
		this.dispatchEvent({type:'removed', modelRef:modelRef});
	}
}
